const QUADRA_DIFFUSION_API_KEY_GOOGLE_MAP = 'AIzaSyCv-YvtnpWFMggWL7BoyahVNxgVPZA9qsE';

export default QUADRA_DIFFUSION_API_KEY_GOOGLE_MAP;
